import { render, staticRenderFns } from "./set16.vue?vue&type=template&id=2fa12d13&scoped=true&"
import script from "./set16.vue?vue&type=script&lang=js&"
export * from "./set16.vue?vue&type=script&lang=js&"
import style0 from "./set16.vue?vue&type=style&index=0&id=2fa12d13&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa12d13",
  null
  
)

export default component.exports